import { render, staticRenderFns } from "./StudioEmailEditor.vue?vue&type=template&id=c0a4ac8e"
import script from "./StudioEmailEditor.vue?vue&type=script&lang=js"
export * from "./StudioEmailEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports